import { OrganizationManagerDashboardPageView } from './OrganizationManagerDashboardPageView';
import { useOrganizationManagerDashboardPage } from './hooks/useOrganizationManagerDashboardPage';

export function OrganizationManagerDashboardPageContainer() {
  const viewProps = useOrganizationManagerDashboardPage();
  return <OrganizationManagerDashboardPageView {...viewProps} />;
}
